<dx-popup
  [visible]="true"
  [showTitle]="true"
  [showCloseButton]="true"
  title="Store tree details"
  width="80%"
  height="80%">
  <app-store-tree></app-store-tree>
</dx-popup>
